import { Card } from "antd"
import { ConvertToAnalystForm } from "../../analyst-signup-request/components/ConvertToAnalystForm"

export const AnalystApplicationFormPage = () => {
  return <Card title="Become analyst" >
    <ConvertToAnalystForm />
  </Card>
}
